exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.validation[data-v-3687d562] {\n    color: red;\n    font-size: 0.8em;\n}\n", ""]);

// exports
